export function goToExternalUrl(url: string, target = '_blank') {
  if (window) {
    window.open(url, target);
  }
}
